<ng-container *ngIf="backgroundVideoEnabled && !userDisabledBackgroundVideo">
    <div class="video-wrapper">
        <div class="video-bg video-default">
            <video #themeVideo id="vid" class="video-bg-video" autoplay loop muted [muted]="'muted'" [src]="videoSrc" type="video/mp4">
            </video>
        </div>
    </div>
</ng-container>
